
import React from 'react';
import { Button } from '../ui/button';
import { Loader2 } from 'lucide-react';
import { TokenPackage } from './constants';
import { trackBeginCheckout } from '@/utils/analytics';

interface TokenPackageCardProps {
  package: TokenPackage;
  loading: string | null;
  onPurchase: (packageId: string) => void;
  formatTokens: (tokens: number) => string;
}

const TokenPackageCard: React.FC<TokenPackageCardProps> = ({
  package: pkg,
  loading,
  onPurchase,
  formatTokens
}) => {
  return (
    <div
      className={`relative p-4 border rounded-lg transition-colors hover:bg-muted/50 ${
        pkg.popular ? 'border-primary bg-muted' : 'border-border'
      }`}
    >
      {pkg.popular && (
        <div className="absolute -top-2 left-1/2 transform -translate-x-1/2">
          <span className="bg-primary text-primary-foreground text-xs px-2 py-1 rounded-full">
            Most Popular
          </span>
        </div>
      )}
      
      <div className="flex items-center justify-between">
        <div>
          <h3 className="font-semibold text-foreground">
            {formatTokens(pkg.tokens)} tokens
          </h3>
          <p className="text-sm text-muted-foreground">
            ${(pkg.price / pkg.tokens * 1000).toFixed(2)} per 1k tokens
          </p>
        </div>
        
        <div className="text-right">
          <p className="text-2xl font-bold text-primary">
            ${pkg.price}
          </p>
          <Button
            onClick={() => {
              trackBeginCheckout(pkg);
              onPurchase(pkg.id);
            }}
            disabled={loading !== null}
            variant="success"
            size="sm"
            className="mt-2"
          >
            {loading === pkg.id ? (
              <Loader2 className="w-4 h-4 animate-spin" />
            ) : (
              'Buy Now'
            )}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default TokenPackageCard;
